"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var startOfDay_1 = __importDefault(require("date-fns/startOfDay"));
var subDays_1 = __importDefault(require("date-fns/subDays"));
var subHours_1 = __importDefault(require("date-fns/subHours"));
var types_1 = require("../../types");
function convertTimePeriodToDate(timePeriod) {
    var now = Date.now();
    switch (timePeriod) {
        case types_1.App.TimePeriodVariants.ONE_HOUR:
            return subHours_1.default(now, 1);
        case types_1.App.TimePeriodVariants.TODAY:
            return startOfDay_1.default(now);
        case types_1.App.TimePeriodVariants.YESTERDAY:
            return startOfDay_1.default(subDays_1.default(now, 1));
        case types_1.App.TimePeriodVariants.THREE_DAYS:
            return subDays_1.default(now, 3);
        case types_1.App.TimePeriodVariants.WEEK:
            return subDays_1.default(now, 7);
        default:
            return timePeriod;
    }
}
exports.default = convertTimePeriodToDate;
//# sourceMappingURL=convertTimePeriodToDate.js.map